import { createApp } from '@backstage/frontend-defaults';
import { convertLegacyPlugin } from '@backstage/core-compat-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import githubActionsPluginBase from '@backstage-community/plugin-github-actions/alpha';
import { githubActionsApiRef } from '@backstage-community/plugin-github-actions';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import argoCdPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { discoveryApiRef, fetchApiRef } from '@backstage/frontend-plugin-api';
import {
  EntityGrafanaAlertsCard,
  EntityGrafanaDashboardsCard,
  EntityOverviewDashboardViewer,
  grafanaPlugin,
  isAlertSelectorAvailable,
  isDashboardSelectorAvailable,
  isOverviewDashboardAvailable,
} from '@k-phoen/backstage-plugin-grafana';
import { navModule } from './modules/nav';
import { environmentsModule } from './modules/environments';
import { anderCicdModule } from './modules/anderCicd';
import { anderTestReportsModule } from './modules/anderTestReports';
import { anderSecurityReportsModule } from './modules/anderSecurityReports';
import { anderSecurityV2FeatureLoader } from './modules/anderSecurityV2';
import { appModuleKeycloakSignIn } from './modules/appModuleKeycloakSignIn';
import { GithubActionsBackendClient } from './modules/githubActions/GithubActionsBackendClient';

const convertedGrafanaPlugin = convertLegacyPlugin(grafanaPlugin, {
  extensions: [
    convertLegacyEntityCardExtension(EntityGrafanaDashboardsCard, {
      name: 'dashboards',
      filter: entity => Boolean(isDashboardSelectorAvailable(entity)),
      type: 'info',
    }),
    convertLegacyEntityCardExtension(EntityGrafanaAlertsCard, {
      name: 'alerts',
      filter: isAlertSelectorAvailable,
      type: 'info',
    }),
    convertLegacyEntityCardExtension(EntityOverviewDashboardViewer, {
      name: 'overview-dashboard',
      filter: isOverviewDashboardAvailable,
      type: 'content',
    }),
  ],
});

const githubActionsPlugin = githubActionsPluginBase.withOverrides({
  extensions: [
    githubActionsPluginBase.getExtension('api:github-actions').override({
      params: defineParams =>
        defineParams({
          api: githubActionsApiRef,
          deps: {
            discoveryApi: discoveryApiRef,
            fetchApi: fetchApiRef,
          },
          factory: ({ discoveryApi, fetchApi }) =>
            new GithubActionsBackendClient({ discoveryApi, fetchApi }),
        }),
    }),
  ],
});

export default createApp({
  features: [
    catalogPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    scaffolderPlugin,
    techdocsPlugin,
    apiDocsPlugin,
    orgPlugin,
    kubernetesPlugin,
    githubActionsPlugin,
    argoCdPlugin,
    convertedGrafanaPlugin,
    notificationsPlugin,
    searchPlugin,
    userSettingsPlugin,
    appModuleKeycloakSignIn,
    navModule,
    environmentsModule,
    anderCicdModule,
    anderTestReportsModule,
    anderSecurityReportsModule,
    anderSecurityV2FeatureLoader,
  ],
});
